<template>
    <div class="container">
        <div class="row" v-show="state.status.isLoading == true || state.status.isRemovingCarts == true">
            <div class="col-xs-12">
                <img src="/images/default/spinner-lg.gif" alt="loading" />
            </div>
        </div>

        <div class="row" v-show="state.status.isLoading == false && state.status.isRemovingCarts == false">
            <div class="col-xs-12" v-show="state.carts.length == 0">
                {{ getLabel('_webcartempty') }}
            </div>

            <!-- Cart status when the cart had to be adjusted -->
            <cart-status>
            </cart-status>

            <div class="col-md-8 col-xs-12">
                <ul class="carts">                    
                    <cart v-for="cart in state.carts" v-bind:cart="cart" :key="cart.Id">
                    </cart>                    
                </ul>
            </div>
            <div class="col-md-4 col-xs-12">
                <div class="cart-subtotal" v-show="state.carts.length > 0">
                    <h4>
                        {{ getLabel('Prod_Quantity') }}

                        <span class="pull-right">
                            {{ state.quantity }}
                        </span>
                    </h4>

                    <div class="form-group" v-show="state.carts.length > 0">
                        <a href="#removeCarts" class="pull-right" v-on:click="removeCarts($event)">
                            <span class="glyphicon glyphicon-remove"></span>
                            {{ this.getLabel('_removeCarts') }}
                        </a>
                        <div class="clearfix"></div>
                    </div>

                    <h4 v-if="state.settings.ShowPrice == true">
                        {{ getLabel('subtotal') }}

                        <span class="pull-right">
                            <span class="text-uppercase">
                                {{ state.settings.Currency }}
                            </span>
                            $ {{ state.subTotal | roundNumber }}
                        </span>
                    </h4>

                    <div class="default-sm-row">
                        <a class="btn btn-primary form-control"
                            v-bind:href="'/' + state.settings.customerId + '/checkout/checkout'">
                            {{ getLabel('placeorder') }}
                        </a>
                    </div>

                    <span class="help-block"
                        v-if="state.settings.ChargeForShipping == true && state.settings.ChargeForProduct == true">
                        {{ getLabel('_shippingChargesWillBeCalculated') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { store } from './../store.js';
import { shared } from './../shared.js';

import cart from './../components/cart-item.vue';
import cartStatus from './../components/cart-status.vue';

export default {
    name: 'IndexView',
    components: {
        'cart': cart,
        'cart-status': cartStatus
    },
    mixins: [shared],
    data: function () {
        return {
            state: store.state
        }
    },
    methods: {
        removeCarts: function (event) {
            event.preventDefault();     
            store.removeCarts();       
        }
    }    
}
</script>
